import React from 'react';
import { ApplicationSettingsFormWrapper } from './ApplicationSettingsFormWrapper';

export function AppConfigurationPage() {
    return (
        <ApplicationSettingsFormWrapper />
    );
}
